// import React from "react";

// const experience = () => {
//   return (
//     <div>
//       {" "}
//       <div>
//         <form className="grid max-w-4xl text-[#400167]   grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium">Name of Company</label>
//             <input
//               type="text"
//               placeholder="company"
//               className="mt-1 w-full outline-none border-[#D0D0D0] border-2 px-4 py-4 rounded-xl"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium">Position</label>
//             <input
//               type="text"
//               placeholder="position"
//               className="mt-1 w-full outline-none border-[#D0D0D0] border-2 px-4 py-4 rounded-xl"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium">Start Year</label>
//             <input
//               type="text"
//               placeholder="dd/mm/yyyy"
//               className="mt-1 w-full outline-none border-[#D0D0D0] border-2 px-4 py-4 rounded-xl"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium">End Year</label>
//             <input
//               type="text"
//               placeholder="Degree"
//               className="mt-1 w-full outline-none  border-[#D0D0D0] border-2 px-4 py-4 rounded-xl "
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium">End Year</label>
//             <select className="mt-1 w-full border-[#D0D0D0] border-2 px-4 py-4 rounded-xl">
//               <option>Select level</option>
//             </select>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default experience;

import React, { useEffect, useState } from "react";

/**
 * WorkExperienceSimple
 * - Single-file, minimal implementation
 * - Controlled inputs, add/remove entries, simple file attachment (no preview)
 * - Download as CV produces a plain-text file with entered data
 *
 * Replace Tailwind classes if you don't use Tailwind.
 */

const emptyExperience = () => ({
  company: "",
  position: "",
  employmentType: "",
  start: "",
  end: "",
  description: "",
  portfolioLink: "",
  documents: [], // File[]
});

export default function WorkExperienceSimple({ data, onDataChange }) {
  const [items, setItems] = useState(
    Array.isArray(data) && data.length > 0 ? data : [emptyExperience()],
  );

  useEffect(() => {
    onDataChange?.(items);
  }, [items, onDataChange]);

  const addExperience = () => setItems((s) => [...s, emptyExperience()]);

  const removeExperience = (index) =>
    setItems((s) => s.filter((_, i) => i !== index));

  const updateField = (index, field, value) =>
    setItems((s) =>
      s.map((it, i) => (i === index ? { ...it, [field]: value } : it)),
    );

  const handleFileChange = (index, e) => {
    const files = Array.from(e.target.files || []);
    updateField(index, "documents", files);
    // reset input so same file can be selected again if removed
    e.target.value = "";
  };

  return (
    <div className="p-6 max-w-7xl font-Outfit mx-auto">
      <h1 className="text-2xl font-semibold mb-6">Work Experience</h1>

      <div className="space-y-6">
        {items.map((it, idx) => (
          <div
            key={idx}
            className="p-4 text-base  bg-white"
          >
            <div className="flex justify-between items-start">
              <h3 className="text-sm font-medium">Experience {idx + 1}</h3>
              <button
                type="button"
                onClick={() => removeExperience(idx)}
                className="text-sm text-red-600"
                aria-label={`Remove experience ${idx + 1}`}
              >
                Remove
              </button>
            </div>

            <div className="grid grid-cols-1 text-base sm:grid-cols-2 gap-4 mt-4">
              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">
                  Name of Company
                </span>
                <input
                  type="text"
                  value={it.company}
                  onChange={(e) => updateField(idx, "company", e.target.value)}
                  placeholder="Company"
                  className="border px-3 py-2 rounded"
                />
              </label>

              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">Position</span>
                <input
                  type="text"
                  value={it.position}
                  onChange={(e) => updateField(idx, "position", e.target.value)}
                  placeholder="Position"
                  className="border px-3 py-2 rounded"
                />
              </label>

              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">Employment Type</span>
                <select
                  value={it.employmentType}
                  onChange={(e) => updateField(idx, "employmentType", e.target.value)}
                  className="border px-3 py-2 rounded"
                >
                  <option value="">Select employment type</option>
                  <option value="full-time">Full-time</option>
                  <option value="contract">Contract</option>
                  <option value="internship">Internship</option>
                </select>
              </label>

              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">Start Date</span>
                <input
                  type="date"
                  value={it.start}
                  onChange={(e) => updateField(idx, "start", e.target.value)}
                  className="border px-3 py-2 rounded"
                />
              </label>

              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">End Date</span>
                <input
                  type="date"
                  value={it.end}
                  onChange={(e) => updateField(idx, "end", e.target.value)}
                  className="border px-3 py-2 rounded"
                />
              </label>

              <label className="sm:col-span-2 flex flex-col">
                <span className="text-sm text-gray-700 mb-2">
                  Describe your contributions and experience
                </span>
                <textarea
                  value={it.description}
                  onChange={(e) =>
                    updateField(idx, "description", e.target.value)
                  }
                  placeholder="Write here"
                  rows={5}
                  className="border px-3 py-2 rounded"
                />
              </label>

              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">
                  Link to portfolio
                </span>
                <input
                  type="url"
                  value={it.portfolioLink}
                  onChange={(e) =>
                    updateField(idx, "portfolioLink", e.target.value)
                  }
                  placeholder="Enter link"
                  className="border px-3 py-2 rounded"
                />
              </label>

              <label className="flex flex-col">
                <span className="text-sm text-gray-700 mb-2">
                  Upload document(s)
                </span>
                <input
                  type="file"
                  multiple
                  onChange={(e) => handleFileChange(idx, e)}
                  className="border px-3 py-2 rounded"
                />
              </label>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center gap-4">
        <button
          type="button"
          onClick={addExperience}
          className="w-10 h-10 flex items-center justify-center border rounded text-xl"
          aria-label="Add experience"
        >
          +
        </button>
      </div>
    </div>
  );
}
